import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { components, contentfulModels } from '@glowforge/ui-common';


import { machineUsersPropType, machinePropType } from 'app/selectors/machines';
import ChangeAccessDialogContainer from 'app/containers/settings/change-access-dialog';
import { renderMachineCell } from './machine-cell';

import './users.less';

// TODO: This should eventually come from ui-common?
const PremiumIcon = require('./premium-gem-yellow.svg');

const { pageStringsPropType } = contentfulModels;
const { Markdown, SVG } = components;

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = { showAccessDialogUser: null };
  }

  showAccessDialog = (user) => {
    this.setState({ showAccessDialogUser: user });
  };

  hideAccessDialog = () => {
    this.setState({ showAccessDialogUser: null });
  };

  render() {
    const { machines, managedMachines, isLoading, pageStrings, pageMarkdownStrings, users } = this.props;
    const { showAccessDialogUser } = this.state;
    if (_.isEmpty(machines) && !isLoading) {
      return (
        <div className='Users empty'>
          <Markdown source={pageMarkdownStrings['settings-users-tab-no-machines']} />
        </div>
      );
    }

    if (_.isEmpty(managedMachines) && !isLoading) {
      return (
        <div className='Users empty'>
          <Markdown source={pageMarkdownStrings['settings-users-tab-not-a-manager']} />
        </div>
      );
    }

    if (_.isEmpty(users) && !isLoading) {
      return (
        <div className='Users empty'>
          <Markdown source={pageMarkdownStrings['settings-no-users-on-machine']} />
        </div>
      );
    }

    let loading;
    if (isLoading) {
      loading = <div className='loadingIndicator'><SVG id='spinner' /></div>;
    }

    const membershipIndicator = () => (
      (
        <span className='premiumMember'>
          <PremiumIcon className='premiumIcon' />
          {pageStrings['settings-users-subscription-member']}
        </span>
      )
    );

    // TODO: what does this page look like for an added user of the subscription?

    const rows = _.map(users, (user, index) => {
      const showAccessForUser = () => this.showAccessDialog(user);

      if (this.props.isSubscriber) {
        const activeUsers = this.props.subscriptionUsers;

        // TODO: is email the right comparison? it's really the only one we have here.
        const isMember = _.find(activeUsers, u => u.attributes.secondary_user_email === user.email);
        return (
          <tr key={index} onClick={showAccessForUser}>
            <td className='name'>
              {user.name}
            </td>
            <td className='member'>
              {isMember ? membershipIndicator() : ''}
            </td>
            <td>
              {renderMachineCell(user.machines)}
            </td>
          </tr>
        );
      }
      return (
        <tr key={index} onClick={showAccessForUser}>
          <td className='name'>
            {user.name}
          </td>
          <td>
            {renderMachineCell(user.machines)}
          </td>
        </tr>
      );
    });

    const userNameHeader = pageStrings['settings-users-headers-username'] || 'User Name';
    const accessHeader = pageStrings['settings-users-headers-access'] || 'Access To ...';
    const membershipHeader = pageStrings['settings-users-headers-membership'] || 'Premium Membership';
    let tableHeaders = (
      <tr className='header label'>
        <th>{userNameHeader}</th>
        <th>{accessHeader}</th>
      </tr>
    );
    if (this.props.isSubscriber) {
      tableHeaders = (
        <tr className='header label'>
          <th>{userNameHeader}</th>
          <th>{membershipHeader}</th>
          <th>{accessHeader}</th>
        </tr>
      );
    }

    return (
      <div className='Users'>
        <div className='tableWrapper'>
          <table className={`styledTable striped ${isLoading ? 'loading' : ''}`}>
            <thead>
              {tableHeaders }
            </thead>
            <tbody>
              {rows}
            </tbody>
          </table>
          {loading}
        </div>
        <ChangeAccessDialogContainer
          {...this.props}
          closeDialog={this.hideAccessDialog}
          isOpen={!!showAccessDialogUser}
          user={showAccessDialogUser} />
      </div>
    );
  }
}

Users.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape(machineUsersPropType)),
  machines: PropTypes.arrayOf(PropTypes.shape(machinePropType)),
  managedMachines: PropTypes.arrayOf(PropTypes.shape(machinePropType)),
  pageStrings: pageStringsPropType.isRequired,
  pageMarkdownStrings: pageStringsPropType.isRequired,
  isLoading: PropTypes.bool,
  isSubscriptionActive: PropTypes.bool,
  isSubscriber: PropTypes.bool,
  subscriptionUsers: PropTypes.array, // eslint-disable-line
};

Users.defaultProps = {
  users: [],
  machines: [],
  managedMachines: [],
  isLoading: false,
  isSubscriptionActive: false,
  isSubscriber: false,
  subscriptionUsers: [],
};

export default Users;



// WEBPACK FOOTER //
// ./app/components/settings/users.jsx